import React from "react";
import { UseFormReturn } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { FormCheck, FormInput } from "go-form";
import { FormDatePicker } from "go-form/components/FormDatePicker";
import { ApplicationApi } from "../../../../../../../../../services/Api/Organization/types";

interface Props {
	form: UseFormReturn<ApplicationApi>;
	provider: string;
}

const GoPosBasicInfoForm = ({ form, provider }: Props) => {
	const { t } = useTranslation();
	const {
		formState: { errors },
		register,
		control,
	} = form;

	return (
		<>
			<h5>{t("common.word.basic_info")}</h5>
			<fieldset>
				<div className="row">
					<div className="col-md-4">
						<FormInput name="name" errors={errors} register={register} label={t("lib:common.word.name")} />
					</div>
					<div className="col-md-4">
						<FormDatePicker
							errors={errors}
							control={control}
							name="settings.START_DATE"
							label={t("modules.app.field.start_synchronize_date.title")}
						/>
					</div>
					<div className="col-md-4">
						<FormDatePicker
							errors={errors}
							control={control}
							name="settings.STOP_DATE"
							label={t("modules.app.field.stop_synchronize_date.title")}
						/>
					</div>
				</div>
				<div className="row">
					<div className="col-md-4">
						<FormCheck
							type="switch"
							errors={errors}
							name="settings.ACTIVE_SYNC"
							label={t("modules.app.field.active_sync.title")}
							register={register}
							help={t("modules.app.field.active_sync.help_text")}
						/>
					</div>
				</div>
			</fieldset>
		</>
	);
};

export default GoPosBasicInfoForm;
